document.addEventListener('DOMContentLoaded', () => {
  // Initialize YouTube Players for all blocks
  document.querySelectorAll('.youtube-player-block').forEach(block => {
    const blockId = block.dataset.blockId;
    const videoId = block.dataset.videoId;
    const playButton = document.getElementById(`play-button-${blockId}`);
    const container = document.getElementById(`video-container-${blockId}`);

    if (playButton && container) {
      playButton.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.className = 'youtube-iframe';
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        iframe.title = "YouTube video player";
        iframe.frameBorder = "0";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.allowFullscreen = true;

        container.innerHTML = '';
        container.appendChild(iframe);
      });
    }
  });

  // Initialize Carousel if it exists
  const carouselContainer = document.querySelector('.videos-with-cover-layout-carousel');
  if (carouselContainer && typeof Swiper !== 'undefined') {
    const swiper = new Swiper('.swiper-container', {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 200,
        modifier: 1,
        slideShadows: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChange: function () {
          const activeSlide = this.slides[this.activeIndex];
          const videoTitle = activeSlide.dataset.videoTitle;
          const titleElement = carouselContainer.querySelector('.carousel-video-title');
          if (titleElement) {
            titleElement.textContent = videoTitle;
          }
        },
        init: function(){
          // Set initial title
          setTimeout(() => {
            const activeSlide = this.slides[this.activeIndex];
            const videoTitle = activeSlide.dataset.videoTitle;
            const titleElement = carouselContainer.querySelector('.carousel-video-title');
            if (titleElement) {
              titleElement.textContent = videoTitle;
            }
          }, 100)
        }
      },
    });
  }
});
